import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { TrendingUp, Zap, Heart, ShieldCheck, Activity, Maximize } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: Maximize,
    title: 'Aumento de Tamaño Real',
    desc: 'Resultados visibles que transforman tu anatomía de forma natural.'
  }, {
    icon: Zap,
    title: 'Mayor Potencia',
    desc: 'Energía explosiva cuando más la necesitas, sin fatiga.'
  }, {
    icon: Heart,
    title: 'Confianza Total',
    desc: 'Elimina la inseguridad y domina cada encuentro.'
  }, {
    icon: Activity,
    title: 'Mejor Circulación',
    desc: 'Optimiza el flujo sanguíneo para una salud integral.'
  }, {
    icon: ShieldCheck,
    title: '100% Seguro',
    desc: 'Sin efectos secundarios, dolores de cabeza ni riesgos.'
  }, {
    icon: TrendingUp,
    title: 'Transformación Completa',
    desc: 'Mejora tu físico, tu mente y tu desempeño global.'
  }];
  return <Section background="dark" data-id="element-12">
      <div className="text-center mb-16" data-id="element-13">
        <h2 className="text-3xl md:text-4xl font-bold text-white uppercase leading-tight mb-4" data-id="element-14">
          ESTO ES EXACTAMENTE LO QUE{' '}
          <span className="text-[#FF6B00]" data-id="element-15">DESBLOQUEARÁS</span> CON VARAMAX
        </h2>
        <div className="h-1 w-24 bg-[#22C55E] mx-auto rounded-full" data-id="element-16"></div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
        {benefits.map((benefit, idx) => <Card key={idx} className="hover:bg-[#1F331F] transition-colors group cursor-default border border-transparent hover:border-[#22C55E]/30" data-id="element-18">
            <div className="bg-[#22C55E]/10 w-14 h-14 rounded-full flex items-center justify-center mb-6 group-hover:bg-[#22C55E] transition-colors" data-id="element-19">
              <benefit.icon className="w-7 h-7 text-[#22C55E] group-hover:text-white transition-colors" data-id="element-20" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-21">
              {benefit.title}
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-22">
              {benefit.desc}
            </p>
          </Card>)}
      </div>
    </Section>;
}